import { render, staticRenderFns } from "./auction-halls-program.vue?vue&type=template&id=5f75348e&"
import script from "./auction-halls-program.vue?vue&type=script&lang=js&"
export * from "./auction-halls-program.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports